import {
  primaryBrightBlue,
  medBlue,
  darkGrey,
  darkModeTextColor,
  darkModeDarkTextColor,
  darkModeBackgroundColor,
  darkModeCardBackgroundColor,
} from "constants/colors";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
  Theme,
} from "@mui/material/styles";

// TECHDEBT: once migrated into rookery, use ThemeManager from @raven/shared/components
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: primaryBrightBlue,
    },
    secondary: {
      main: medBlue,
    },
    text: {
      primary: "#000",
      secondary: darkGrey,
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: primaryBrightBlue,
    },
    secondary: {
      main: medBlue,
    },
    text: {
      primary: darkModeTextColor,
      secondary: darkModeDarkTextColor,
    },
    background: {
      default: darkModeBackgroundColor,
      paper: darkModeCardBackgroundColor,
    },
  },
});

export const ThemeManager = ({
  theme,
  children,
}: {
  theme: Theme;
  children: React.ReactNode;
}): React.JSX.Element => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </StyledEngineProvider>
);
